import axios from 'axios'
import CryptoJS from 'crypto-js'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

//http://mcs-cas-exp-shein-apis.intsit.sfcloud.local:8000/
let api = process.env.VUE_APP_INTERFACE_API //'https://shein-order-web.sit.sf-express.com/'

export default api

let apiEncryption = function (params) {
  // var param = []
  // if (params.orderNo) {
  //   param.push(params.orderNo)
  // }

  var param = JSON.stringify(params)
  console.log('数据处理')

  console.log(param)

  var keyStr = 'l5TJHfZrmY38Hf2e2H1h0Q=='
  console.log(keyStr)

  var key = CryptoJS.enc.Utf8.parse(keyStr)
  var srcs = CryptoJS.enc.Utf8.parse(param)
  console.log(param)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })

  console.log(param)
  console.log(encrypted.toString())

  return encrypted.toString()
}

// 通过运单号获取订单号
export const getOrderDetailAndList = params => {
  console.log('getOrderDetailAndList', params)
  params = apiEncryption(params)

  return axios.post(api + `orderBatchList`, { params: params })
}

// 通过运单号获取订单号
export const getValidToken = params => {
  params = apiEncryption(params)

  return axios.post(api + `orderBatchSlide`, { params: params })
}
